import { ChakraProvider } from '@chakra-ui/react';
import { ThemeProviderProps } from './types';
import { theme } from '@components';

const ThemeProvider = ({ children }: ThemeProviderProps) => {
  return <ChakraProvider theme={theme}>{children}</ChakraProvider>;
};

export default ThemeProvider;
